// extracted by mini-css-extract-plugin
export default {"textContainer":"Event18_textContainer__P+fwM","text":"Event18_text__GleQ7"};